import api from '@/utils/api'
import type { UploadedQuestionImage } from '@/api/questionBanks'

/**
 * 题目图片上传（仅管理员）。
 * 单次最多 50 张，单张 ≤5MB，支持 jpg/jpeg/png/gif/webp；
 * 返回 filename→url 映射所需的列表（filename 为原始文件名，作为导入 JSON 的 imageRef）。
 */
export const uploadApi = {
  async uploadQuestionImages(files: File[]): Promise<UploadedQuestionImage[]> {
    if (files.length === 0) {
      return []
    }
    const formData = new FormData()
    for (const file of files) {
      formData.append('files', file)
    }
    const response = await api.post('/question-banks/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data?.images ?? []
  }
}
